<template>
	<v-card
		class="pb-5"
		max-width="600"
		:min-width="minWidth"
		:min-height="minHeight"
		:style="{
			border: `1px solid ${borderColor}`,
			borderRadius: '4px',
		}"
	>
		<v-card-text>
			<v-row>
				<v-col
					class="py-1 align-center justify-start font-weight-bold text-subtitle-1"
				>
					{{ displayDatum.tagGroupName }}
				</v-col>
			</v-row>
			<v-row class="font-weight-bold border-bottom border-color">
				<v-col v-if="hasAxisData(displayDatum)" cols="3">
					{{ headerRow.axisLabel }}
				</v-col>
				<v-col :cols="hasAxisData(displayDatum) ? 5 : 6">
					{{ headerRow.valueLabel }}
				</v-col>
				<v-col :cols="hasAxisData(displayDatum) ? 4 : 6">
					{{ headerRow.tagNameLabel }}
				</v-col>
			</v-row>
			<v-row
				v-for="(row, index) in displayDatum.rowData"
				:key="row.tagName"
				:class="{
					'border-bottom': index !== displayDatum.rowData.length - 1,
				}"
			>
				<v-col
					v-if="hasAxisData(displayDatum)"
					class="py-1 align-center"
					cols="3"
				>
					<div v-if="row.axis">
						<v-icon size="x-small"> mdi-chart-line </v-icon>
						{{ row.axis }}
					</div>
					<div
						v-else-if="row.fromBroadcast && row.datasetUuid"
						title="Per-branch default tag"
					>
						<v-icon size="x-small"> mdi-chart-line-variant </v-icon>
					</div>
					<div v-else-if="row.fromBroadcast" title="Graph-wide default tag">
						<v-icon size="x-small"> mdi-chart-line </v-icon>
					</div>
				</v-col>
				<v-col
					class="py-1 align-center"
					:cols="hasAxisData(displayDatum) ? 5 : 6"
				>
					{{ row.value }}
				</v-col>
				<v-col
					class="py-1 align-center"
					:cols="hasAxisData(displayDatum) ? 4 : 6"
				>
					{{ row.tagName }}
				</v-col>
			</v-row>
			<div v-if="!isAbbreviation">
				<v-divider class="my-8 mx-n4 opacity-100" :color="borderColor" />
				<div
					v-if="displayDatum.compositeKeyData.length > 0"
					class="position-relative"
				>
					<v-row>
						<v-col
							v-for="item in displayDatum.compositeKeyData"
							:key="item.value"
							:cols="12 / displayDatum.compositeKeyData.length"
							class="py-1 d-flex align-center text-caption font-weight-bold"
						>
							{{ item.label }}
						</v-col>
					</v-row>
					<v-row>
						<v-col
							v-for="item in displayDatum.compositeKeyData"
							:key="item.value"
							:cols="12 / displayDatum.compositeKeyData.length"
							class="py-1 text-caption"
						>
							{{ item.value }}
						</v-col>
					</v-row>
				</div>
				<div v-else>
					<v-row>
						<v-col class="py-1 align-center">
							<v-icon class="mr-3" color="red" size="small">
								mdi-alert-circle
							</v-icon>
							Missing study branch
						</v-col>
					</v-row>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { useTheme } from "vuetify";

export default {
	name: "VMetadataPreviewCard",

	props: {
		displayDatum: {
			type: Object,
			required: true,
		},
		headerRow: {
			type: Object,
			required: true,
		},
		minWidth: {
			type: Number,
			default: 300,
		},
		minHeight: {
			type: Number,
			default: 100,
		},
	},

	setup() {
		const theme = useTheme();
		return { theme };
	},

	computed: {
		borderColor() {
			return this.theme.current.value.colors.secondary;
		},
		isAbbreviation() {
			return this.displayDatum.tagGroupName === "Definitions and abbreviations";
		},
	},

	methods: {
		hasAxisData(displayDatum) {
			return displayDatum.rowData.some(
				(row) => !!row.axis || !!row.fromBroadcast,
			);
		},
	},
};
</script>

<style scoped lang="scss">
.border-bottom {
	position: relative;
}

.border-bottom::after {
	content: "";
	position: absolute;
	bottom: 0;
	left: 8px;
	right: 8px;
	border-bottom: 1px solid var(--border-default);
}
</style>
